import { MetricDomain } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const metricRouteLoadDimensions = createAction(
  '[Metric Route] Load Dimensions',
  props<{ metricToken: string }>()
);

export const metricRouteLoadDimensionsSuccess = createAction(
  '[Metric Route] Load Dimensions Success',
  props<{ dimensions: ReadonlyArray<MetricDomain.Dimension> }>()
);

export const metricRouteLoadDimensionsFailure = createAction(
  '[Metric Route] Load Dimensions Failure',
  props<{ error: any }>()
);
